import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import ListItem from '@material-ui/core/ListItem';

import Card from '@material-ui/core/Card';

const BREAKPOINT = 1200;

const optionCheckboxes = [
  { value: 'shopping', label: 'Shopping', color: 'rgb(255, 149, 0)' },
  { value: 'office', label: 'Office', color: 'rgb(46, 208, 230)' },
  { value: 'transportation', label: 'Transportation', color: 'rgb(158, 100, 235)' },
  { value: 'education', label: 'Education', color: 'rgb(62, 147, 217)' },
  { value: 'hospital', label: 'Healthy', color: 'rgb(228, 117, 83)' },
  { value: 'park', label: 'Park', color: 'rgb(181, 230, 46)' },
  { value: 'future', label: 'Future', color: 'rgb(247, 220, 111)' },
];

// embassy rgb(158, 100, 235)

const Container = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  transition: all .6s ease-out;

  @media print {
    display: none;
  }
`;


const LegendWrapper = styled.div`
  font-size: 11px;
  color: #787878;
  margin: 0 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;

  opacity: ${props => props.disabled ? 0.5 : 1};
`;

const ColorBox = styled.div`
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 14px;
  background: ${props => props.color || '#ececec'};
`;


const Legend = ({ label, color, checked }) => (
  <LegendWrapper disabled={!checked}>
    <ColorBox color={color} checke={checked} />
    <Typography style={{ fontSize: 12 }}>{label}</Typography>
  </LegendWrapper>
)

const ListLegendWrapper = styled.div`
  display: block;
  @media (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

const ListLegendWrapperDesktop = styled.div`
  display: none;
  @media (min-width: ${BREAKPOINT}px) {
    display: flex;
    flex-direction: row;
    min-width: 600px;
  }
`;

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    layout: state.domain.design.legend,
    viewOptions: state.domain.map.facilityViewOptionList,
  }
}

export default connect(
  mapStateToProps,
)(class extends React.Component {

  static getDerivedStateFromProps (nextProps, prevState) {
    return {
      checked: nextProps.viewOptions,
    }
  }
  state = {
    open: false,
    checked: [],

    // layout B
    openPopover: false,
  }

  handleClick = () => {
    this.setState({ open: !this.state.open });
  }

  handleToggle = value => () => {
    const { dispatch } = this.props;
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });

    dispatch({
      type: 'DOMAIN/MAP/FACILITYOPTION/CHANGE',
      values: newChecked,
    });
  };

  openPopover = (e) => {
    this.setState({
      openPopover: true,
    })
  }

  handleClosePopover = (e) => {
    this.setState({
      openPopover: false,
    })
  }

  render() {
    const { checked } = this.state;

    return (
      <Container>
          <Paper elevation={12} style={{ background: 'white', display: 'flex' }}>
            <ListLegendWrapperDesktop>
              {_.map(optionCheckboxes, item => {
                const checkedValue = checked.indexOf(item.value) !== -1;
                return (
                  <ListItem key={item.value} dense disableGutters button onClick={this.handleToggle(item.value)}>
                    <Legend checked={checkedValue} label={item.label} color={item.color} />
                  </ListItem>
                );
              })}
            </ListLegendWrapperDesktop>
          </Paper>
        </Container>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/FacilityLegend/index.js